var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H10C9.44772 3 9 3.44772 9 4V6C9 6.55228 9.44772 7 10 7H21C21.5523 7 22 6.55228 22 6C22 4.34315 20.6569 3 19 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H4C2.89543 8 2 8.89543 2 10V11C2 11.5523 2.44772 12 3 12H7.41667L10.6392 14.4169L6.99813 17.2665C6.70438 17.097 6.36351 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19C8 18.8084 7.97305 18.6231 7.92274 18.4476L11.882 15.349L16.0663 18.4873C16.0231 18.6509 16 18.8228 16 19C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19C20 17.8954 19.1046 17 18 17C17.6218 17 17.2681 17.105 16.9665 17.2874L13.1055 14.3916L16.1614 12H21C21.5523 12 22 11.5523 22 11V10C22 8.89543 21.1046 8 20 8ZM11.8626 13.4595L9.91667 12H13.7275L11.8626 13.4595Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7C5.10457 7 6 6.10457 6 5C6 3.89543 5.10457 3 4 3C2.89543 3 2 3.89543 2 5C2 6.10457 2.89543 7 4 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedPatient);
export default __webpack_public_path__ + "static/media/bed-patient.7af3f3f41c0463f04930dd950a4a9b4b.svg";
export { ForwardRef as ReactComponent };